import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex title justify-space-between" }
const _hoisted_2 = {
  key: 0,
  class: "text--secondary"
}
const _hoisted_3 = { class: "text-secondary font-weight-regular pr-1" }
const _hoisted_4 = { class: "font-weight-medium" }
const _hoisted_5 = { class: "caption text--secondary pt-1" }
const _hoisted_6 = { class: "caption text--secondary" }
const _hoisted_7 = { class: "subtitle-1 font-weight-medium" }
const _hoisted_8 = { class: "text--secondary font-weight-regular" }
const _hoisted_9 = { class: "subtitle-1 font-weight-medium" }
const _hoisted_10 = { style: {"max-height":"calc(100vh - 133px)","overflow":"auto"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "d-flex flex-column pa-2",
    style: {"width":"100vw"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event)),
        horizontal: "",
        style: {"max-height":"calc(100vh - 133px)"}
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_v_window_item, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex flex-column align-center justify-center pb-3 pb-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.formatCategory(_ctx.document.type)), 1),
                      (_ctx.document.invoiceNumber)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Facture n°" + _toDisplayString(_ctx.document.invoiceNumber), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pa-2 mb-2 oss-list-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "py-2 pl-3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, " Status | " + _toDisplayString(_ctx.documentStatus), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.showThirdPartyCompany)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12",
                        class: "pa-2 mb-2 pl-5 oss-list-item"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.document.thirdPartyCompany ? _ctx.document.thirdPartyCompany.name : ""), 1),
                          _createElementVNode("div", _hoisted_5, " Siret : " + _toDisplayString(_ctx.document.thirdPartyCompany && _ctx.document.thirdPartyCompany.siret
                                    ? _ctx.getSiretValue(_ctx.document.thirdPartyCompany.siret)
                                    : ""), 1),
                          _createElementVNode("div", _hoisted_6, "Adresse : " + _toDisplayString(_ctx.fullAddress), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pa-2 mb-2 oss-list-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "d-flex flex-column py-2 pl-3" }, {
                            default: _withCtx(() => [
                              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text--secondary font-weight-regular" }, " Date du document ", -1)),
                              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatDate(_ctx.document.date)), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.dueDateEnable)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "6",
                                class: "d-flex flex-column py-2 pl-3 border-left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("shared.dueDate")), 1),
                                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatDate(_ctx.dueDate)), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.showDetail)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 1,
                        cols: "12",
                        class: "py-2 mb-2 oss-list-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_accounting_item_static, {
                            companyId: _ctx.companyId,
                            documentId: _ctx.document.id,
                            onUpdate: _ctx.startToBeDoneIfNecessary,
                            mode: "Payment"
                          }, null, 8, ["companyId", "documentId", "onUpdate"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.activateTagguing && _ctx.document.type !== 'EXPENSE_REPORT_DOCUMENT')
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 2,
                        cols: "12",
                        class: "pa-2 mb-2 oss-list-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FreeTag, {
                                    companyTags: _ctx.allCompanyTags,
                                    document: _ctx.inDocument,
                                    outlined: true,
                                    onChanged: _ctx.startToBeDoneIfNecessary
                                  }, null, 8, ["companyTags", "document", "onChanged"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
          (_openBlock(), _createBlock(_component_v_window_item, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                (_ctx.isPDF)
                  ? (_openBlock(), _createBlock(_component_ossPdf, {
                      key: 0,
                      documentId: _ctx.document.id
                    }, null, 8, ["documentId"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "document-display",
                      style: _normalizeStyle({
                            backgroundImage: `url(${_ctx.document.signedUrl})`,
                            height: `calc(${_ctx.imageHeight} * calc(100vw - 16px) / ${_ctx.imageWidth})`,
                        })
                    }, null, 4))
              ])
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.document.signedUrl)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            "no-gutters": "",
            class: "pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    style: {"width":"55%"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onStep())),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.step ? "Voir les informations" : "Voir le document"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.openChat)
        ? (_openBlock(), _createBlock(_component_Chat, {
            key: 1,
            id: _ctx.document.chat ? _ctx.document.chat.id : '',
            status: 'INFORMATION_REQUEST'
          }, null, 8, ["id"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}